module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-view"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('erco-header', {
    attrs: {
      "name": _vm.objectName,
      "id": _vm.objectId,
      "processstate": _vm.processState
    },
    on: {
      "change": _vm.handleActionChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [(_vm.objectIsLoading || _vm.isUpdatingStatus) ? _c('erco-cloak') : _vm._e(), _vm._v(" "), (!_vm.objectIsLoading) ? _c('div', {
    staticClass: "frame-inner"
  }, [(_vm.objectUrl) ? _c('iframe', {
    staticClass: "iframe",
    attrs: {
      "src": _vm.objectUrl
    }
  }) : _c('div', {
    staticClass: "not-found-info"
  }, [_c('b-alert', {
    staticClass: "info-text",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v("\n\t\t\t\t\tDas Objekt besitzt noch keine URL\n\t\t\t\t")])], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70482e38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ErcoLiveView.vue
// module id = 633
// module chunks = 0